import { t } from "i18next";
import { MessageChat } from "../types";

// limites
export const getPreviewContentMessageChat = (message: MessageChat) => {
    if (message.is_view_once) {
        return message.view_once_opened_at ? "Mensagem aberta" : "Visualização única";
    }

    const types = message.file_type ? JSON.parse(message.file_type) : [];

    if(message.gif_url)
        return `🌇 ${t("chat.message.image")}`;

    if(!types.length)
        return message.text?.replace(/[\r\n]+/g, "");

    const type = types[0];

    if (type?.startsWith('audio/') || type?.startsWith('video/webm'))
        return `🔊 ${t("chat.message.audio")}` 

    if (type?.startsWith('image'))
        return `🌇 ${t("chat.message.image")}` 

    if (type?.startsWith('video'))
        return `🌇 ${t("chat.message.video")}` 

        return `🗃️ ${t("chat.message.document")}` 
}

// export const getPreviewContentMessageChat = (message: any) => {
//     // se vier string simples (caso do last_message do backend)
//     if (typeof message === "string") {
//         return message.replace(/[\r\n]+/g, "");
//     }

//     // se vier no formato antigo (objeto completo)
//     const types = message.file_type ? JSON.parse(message.file_type) : [];

//     if (!types.length)
//         return message.text?.replace(/[\r\n]+/g, "");

//     const type = types[0];

//     if (type?.startsWith("audio/") || type?.startsWith("video/webm"))
//         return "🔊 Mensagem de voz";

//     if (type?.startsWith("image"))
//         return "🌇 Imagem";

//     if (type?.startsWith("video"))
//         return "🎥 Vídeo";

//     return "🗃️ Arquivo";
// };
